import React from 'react';

import { Radio as MUIRadio } from '@mui/material';

import { Typography, styled } from '@liscio/ui';

export interface RadioProps {
  label: string;
  checked?: boolean;
  disabled?: boolean;
  onChange: () => void;
}

const StyledLabel = styled('label')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const Radio: React.FC<RadioProps> = ({
  label,
  checked,
  disabled,
  onChange,
}) => {
  return (
    <StyledLabel>
      <Typography>{label}</Typography>
      <MUIRadio checked={checked} onClick={onChange} disabled={disabled} />
    </StyledLabel>
  );
};

export default Radio;
